module.exports = __webpack_public_path__ + "img/icon_place.54e93abb.svg";